import React, { useState } from "react";
import { Drawer } from "@mantine/core";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import AnnouncementForm from "./AnnouncementForm";

const AnnouncementTableEmptyStateContainer: React.FC = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        size="xl"
        onClose={() => setOpened(false)}
        title="New Announcement"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div style={{ padding: "25px", height: "80%", overflow: "auto" }}>
          <AnnouncementForm onSuccess={() => setOpened(false)} />
        </div>
      </Drawer>
      <EmptyStateContainer
        title="You have no announcements"
        description="Click create new to send an announcement to your employers"
        button={{
          onClick: () => setOpened(true),
          title: "Create New",
        }}
      />
    </>
  );
};

export default AnnouncementTableEmptyStateContainer
